export default function postEnable2FaReducer
  (state = { error:'', success:'', processing:false}, action)
{
  switch (action.type) {
    case 'ENABLE_2FA_SUCCESS':
      return {...state, ...{success: action.success}};

    case 'ENABLE_2FA_ERROR':
      return {...state, ...{error: action.error}};

    case 'ENABLE_2FA_PROCESSING':
      return {...state, ...{processing: action.processing}};

    default: return state;
  }
}